import PropTypes from 'prop-types'
import React from 'react'
import HtmlContent from '../../atoms/HtmlContent'

const TimelineStateMessage = ({ label, message }) => {
  return (
    <div className="break-words mt-1 mb-6">
      <p className="font-bold">{label}</p>
      <HtmlContent html={message} className="hint-html-injected--without-space" />
    </div>
  )
}

export default TimelineStateMessage

TimelineStateMessage.propTypes = {
  label: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
}
